import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { Observable } from 'rxjs';

@Injectable()
export class MessagingService {
  //messages: FirebaseListObservable<any[]>;
  constructor(
    public af:AngularFireDatabase,
  ) {
    //this.messages = this.af.list('/messages') as FirebaseListObservable<any>;
  }

  getMessages(cId:string, limit: number){
    return this.af.list('/messages/' + cId,{
      query: {
        orderByKey: true,
        limitToLast: limit
      }
    }) as FirebaseListObservable<any[]>;
  }

}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/services/messaging.service.ts